import React, { useEffect, useState, useRef } from "react";
import AppBody from "../AppBody";
import Header from "../Header";
import { useQueryUser } from "../../hooks/useQueryUser";
import UserContext from "../../provider/UserContextProvider";
import { WhoAmI } from "../../@types/UserInfo";
import { initializeGTM } from "../../utils/gtm";
const AppRoot: React.FC<Record<string, never>> = () => {
  const [whoami, setWhoami] = useState<WhoAmI | undefined>();
  const gtmInitializedRef = useRef(false);

  useEffect(() => {
    const initializeUser = async (): Promise<void> => {
      if (gtmInitializedRef.current) {
        return;
      }

      try {
        const { data: userData } = await useQueryUser();
        setWhoami(userData);

        if (userData?.whoami?.guid) {
          initializeGTM(userData.whoami.guid);
          gtmInitializedRef.current = true;
        } else {
          console.warn("GTM not initialized: User GUID not available");
        }
      } catch (error) {
        console.error("Failed to initialize user:", error);
      }
    };
    initializeUser();
  }, []);

  return (
    <UserContext.Provider value={whoami}>
      <Header />
      <AppBody />
    </UserContext.Provider>
  );
};

export default AppRoot;
